import { Component, OnInit, OnDestroy, Input, Output,EventEmitter } from '@angular/core';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';

@Component({
    selector: 'share-feedback-select-files-section',
    templateUrl: './select-files.component.html',
    styleUrls: ['./select-files.component.scss']
})
export class PluginShareFeedbackSelectFilesSectionComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;

    public status:number = this.LOADING;
    public filesUrl: string = "";

    @Input() project: Objects.Request;
    @Input() partialProject: Objects.BasicRequest;
    @Input() files: Array<Objects.AmsFile> = [];

    @Output() selectedChange = new EventEmitter<Array<Objects.AmsFile>>()

    /** 
     * TODO: update to add uuid for files new model.
    */

    constructor( public urlSrv: UrlService){}


    ngOnInit() {
        if(this.project != null){
            this.filesUrl = "/projects/" + this.project.id +"/attachments"
        }
        if(this.partialProject != null){
            this.filesUrl = "/projects/" + this.partialProject.id +"/attachments"
        }

    }

    ngOnDestroy(){

    }
    onChange(e: Array<Objects.AmsFile>) {
        // console.log(" cambia  ",e);
        this.setSelected(e);
        this.selectedChange.emit(this.files);
    }

    onRemove(e: Objects.AmsFile) {
        let fileId = e.id;
        let files = this.files.filter(f => f.id != fileId);
        this.setSelected(files);
        this.selectedChange.emit(this.files);

    }

    setSelected(files: Array<Objects.AmsFile>){
        this.files = files;
    }

}
